# LanguageManager.vue
<template>
  <div>
    
  </div>
</template>

<script setup>
import { onMounted, watch, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import { useSettingStore } from '@/stores/settingStore';

const settingStore = useSettingStore();
const { locale } = useI18n();

const updateDirection = async (language) => {
  await nextTick();
  document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('lang', language);
};

// Initialize language settings on component mount
onMounted(async () => {
  const storedLanguage = settingStore.language;
  if (storedLanguage) {
    locale.value = storedLanguage;
    await updateDirection(storedLanguage);
  }
});

// Watch for language changes and update document direction
watch(() => settingStore.language, async (newLanguage) => {
  if (newLanguage) {
    locale.value = newLanguage;
    await updateDirection(newLanguage);
  }
}, { immediate: true });

// Watch for locale changes and update store
watch(locale, async (newLocale) => {
  if (newLocale !== settingStore.language) {
    settingStore.setLanguage(newLocale);
    await updateDirection(newLocale);
  }
}, { immediate: true });
</script>

<style>
/* Add these styles to ensure proper direction transition */
html {
  transition: all 0.3s ease;
}

[dir="rtl"] {
  text-align: right;
}

[dir="ltr"] {
  text-align: left;
}
</style>